<template>
  <div class="modal fade inactivity" tabindex="-1" :id="modalId" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content text-center">
        <div class="modal-body p-4">
          <p class="text-dark">{{ message }}</p>
          <ColoredButton class="w-auto btn--yes" @click="showModal = false;">Ok</ColoredButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColoredButton from './ColoredButton';

export default {
  components: {
    ColoredButton
  },
  data() {
    return {
      message: null,
      showModal: false,
    }
  },
  props: {
    modalId: {
      type: String,
      required: true
    },
    triggerEventName: {
      type: String,
      required: true
    }
  },
  watch : {
    showModal: function(){
      let hashModalId = "#"+this.modalId;
      if(this.showModal) {
        $(hashModalId).modalbs5({
            show: true,
            backdrop: 'static',
            keyboard: false
        })
      } else {
        $(hashModalId).modalbs5('hide');
      }
    }
  },
  mounted() {
    let self = this; // Have to use self to store the reference
    window.eventBus.$on(this.triggerEventName, (message) => {
      self.message = message;
      self.showModal = true;
    });
  }
}
</script>

<style>

</style>